// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__C24NZ","col":"styles_col__hOiK9"};